import React from "react";
import Layout from "components/Layout";
import "styles/legal.css";

const AgbsPage = () => {
  return (
    <Layout>
      <section className="legal-page">
        <div className="legal-shell">
          <h1>Allgemeine Geschäftsbedingungen</h1>

          <p className="legal-meta">
            Für alle Dr. Hoffmann-Dienstleistungen.
          </p>

          <h2>1. Anbieter und Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen gelten für sämtliche Leistungen
            im Zusammenhang mit den unter der Bezeichnung „Dr. Hoffmann-Massage“,
            „Dr. Hoffmann-Prinzip“, „Wake-up-Massage“, „Studiomassage“,
            „Außendienstmassage“ oder vergleichbaren Bezeichnungen angebotenen
            Wellness- und Massageleistungen.
          </p>
          <p>
            Anbieter und Vertragspartner ist, soweit nicht ausdrücklich anders
            angegeben:
          </p>
          <p>
            <b>MediConsult GmbH</b>
            <br />
            <b>Adresse:</b> Cremon 11, 20457 Hamburg, Deutschland
            <br />
            <b>E-Mail:</b> info@mediconsult.group
            <br />
            <b>Tel.:</b> +49 (0)40 457543
            <br />
            <b>Vertretungsberechtigter:</b> Andreas Metz
            <br />
            <b>Handelsregisternr.:</b> HRB 176683
            <br />
            <b>USt-IdNr.:</b> DE217241097
          </p>
          <p>
            Diese AGB gelten gegenüber Verbrauchern und Unternehmern, soweit keine
            abweichenden schriftlichen Vereinbarungen getroffen wurden.
          </p>

          <h2>2. Leistungsbeschreibung</h2>
          <p>
            Dr. Hoffmann-Massagen sind Wellnessdienstleistungen im Bereich der
            Perkussionsmassage. Dabei kommen spezielle
            Massagetechniken und/oder Massagegeräte zum Einsatz, die durch
            schnelle, rhythmische Impulse auf bestimmte Körperbereiche einwirken.
          </p>
          <p>
            Die Dr. Hoffmann-Massage dient insbesondere der kurzfristigen
            Aktivierung, Entspannung, Lockerung und Regeneration im Wellnessbereich.
            Sie kann das subjektive Wohlbefinden fördern, die Muskulatur lockern,
            die Durchblutung anregen, Verspannungsgefühle reduzieren und zu einem
            Gefühl von neuer Energie, Frische und körperlicher Aktivierung beitragen.
          </p>
          <p>
            Die Leistungen sind <b>keine medizinische Behandlung</b>, keine
            Physiotherapie, keine Heilmassage, keine ärztliche Therapie und ersetzen
            keine Untersuchung, Beratung, Diagnose oder Behandlung durch einen Arzt,
            Heilpraktiker, Physiotherapeuten oder sonstigen medizinischen
            Leistungserbringer.
          </p>
          <p>Ein bestimmter medizinischer Erfolg wird nicht geschuldet und nicht garantiert.</p>

          <h2>3. Kein Heilversprechen</h2>
          <p>
            Die angebotenen Massagen erfolgen ausschließlich im Wellness-,
            Präventions-, Entspannungs- und Aktivierungsbereich. Es werden keine
            Krankheiten diagnostiziert, behandelt oder geheilt.
          </p>
          <p>
            Aussagen über mögliche Wirkungen der Massage beziehen sich ausschließlich
            auf allgemeine Wellness- und Wohlfühleffekte, insbesondere Entspannung,
            Aktivierung, subjektive Regeneration, Lockerung und Förderung des
            allgemeinen Wohlbefindens.
          </p>
          <p>
            Kunden mit gesundheitlichen Beschwerden, Vorerkrankungen, Schmerzen,
            akuten Verletzungen, Schwangerschaft, Herz-Kreislauf-Erkrankungen,
            Thrombose, Entzündungen, Hauterkrankungen, neurologischen Erkrankungen,
            Implantaten, frischen Operationen oder sonstigen gesundheitlichen Risiken
            sind verpflichtet, vor der Buchung und Inanspruchnahme der Massage
            ärztlichen Rat einzuholen.
          </p>

          <h2>4. Eigenverantwortung des Kunden</h2>
          <p>Die Inanspruchnahme der Massage erfolgt auf eigene Verantwortung des Kunden.</p>
          <p>
            Der Kunde ist verpflichtet, vor Beginn der Massage vollständig und
            wahrheitsgemäß mitzuteilen, ob gesundheitliche Einschränkungen,
            Schmerzen, Erkrankungen, Verletzungen, Operationen, Schwangerschaft,
            Medikamenteneinnahmen oder sonstige Umstände vorliegen, die gegen eine
            Massage sprechen könnten.
          </p>
          <p>
            Der Kunde ist verpflichtet, während der Massage sofort mitzuteilen, wenn
            Schmerzen, Unwohlsein, Schwindel, Taubheitsgefühle oder sonstige
            Beschwerden auftreten. In diesem Fall kann die Massage sofort abgebrochen
            werden.
          </p>
          <p>
            Die MediConsult GmbH ist berechtigt, eine Massage ganz oder teilweise
            abzulehnen oder abzubrechen, wenn gesundheitliche Bedenken bestehen, der
            Kunde unzutreffende Angaben macht, der Kunde alkoholisiert oder erkennbar
            berauscht erscheint oder sonstige Gründe vorliegen, die eine
            ordnungsgemäße Durchführung unmöglich oder unzumutbar machen.
          </p>
          <p>
            Ein Anspruch auf Erstattung besteht in diesen Fällen nicht, sofern der
            Kunde den Grund für die Ablehnung oder den Abbruch zu vertreten hat.
          </p>

          <h2>5. Angebote, Preise und Massagearten</h2>
          <p>
            Es gelten die zum Zeitpunkt der Buchung ausgewiesenen Preise. Die
            MediConsult GmbH ist berechtigt, Preise, Leistungsinhalte,
            Aktionsangebote und Verfügbarkeiten jederzeit mit Wirkung für zukünftige
            Buchungen zu ändern.
          </p>
          <p>
            Bereits verbindlich gebuchte und bezahlte Leistungen bleiben von späteren
            Preisänderungen unberührt.
          </p>
          <p>Aktuell können insbesondere folgende Leistungen angeboten werden:</p>
          <p>
            <b>a) Studiomassage</b>
            <br />
            Die Studiomassage findet in einem von der MediConsult GmbH oder einem
            Partner benannten Studio statt. Der Preis beträgt derzeit <b>29,00 Euro
            für 10 Minuten</b>.
          </p>
          <p>
            <b>b) Außendienstmassage / Hotelmassage</b>
            <br />
            Die Außendienstmassage findet außerhalb des Studios statt, insbesondere
            in Hotels, Unternehmen, Veranstaltungen oder bei Partnern vor Ort. Der
            Preis beträgt derzeit <b>39,00 Euro für 10 Minuten</b>.
          </p>
          <p>
            <b>c) Wake-up-Massage</b>
            <br />
            Die Wake-up-Massage ist eine kurze Aktivierungs- und Kennenlernmassage.
            Sie kann im Studio oder im Außendienst angeboten werden. Der Aktionspreis
            beträgt derzeit <b>5,00 Euro</b>, sofern der Kunde den vorgesehenen
            Registrierungsprozess vollständig durchläuft und in die vereinbarte
            Foto-, Film- und Marketingnutzung einwilligt.
          </p>
          <p>
            Wünscht der Kunde keine Registrierung und/oder keine Foto-, Film- oder
            Marketingnutzung, kann die Wake-up-Massage, soweit verfügbar, zum Preis
            von <b>10,00 Euro</b> angeboten werden.
          </p>
          <p>
            <b>d) Anfahrtspauschale</b>
            <br />
            Bei Außendienstterminen, mobilen Einsätzen, Hotelterminen oder Terminen
            außerhalb des Studios wird zusätzlich eine Anfahrtspauschale anfallen.
            Diese beträgt derzeit <b>39,00 Euro</b>, sofern im Einzelfall nichts
            anderes vereinbart wurde.
          </p>
          <p>
            Alle Preise verstehen sich exklusive gesetzlicher Umsatzsteuer, sofern
            gegenüber Verbrauchern angeboten. Gegenüber Unternehmern können
            Nettopreise zuzüglich gesetzlicher Umsatzsteuer ausgewiesen werden.
          </p>

          <h2>6. Buchung und Vertragsschluss</h2>
          <p>
            Die Buchung einer Massage erfolgt online, telefonisch, per QR-Code, per
            Formular, per Nachrichtendienst, vor Ort oder über sonstige von der
            MediConsult GmbH bereitgestellte Buchungswege.
          </p>
          <p>
            Mit Abschluss der Buchung gibt der Kunde ein verbindliches Angebot zum
            Abschluss eines Dienstleistungsvertrages ab. Der Vertrag kommt zustande,
            sobald die Buchung bestätigt oder die Leistung begonnen wird.
          </p>
          <p>
            Die Buchung ist verbindlich. Der Kunde ist verpflichtet, den gebuchten
            Termin pünktlich wahrzunehmen und die vereinbarte Vergütung zu bezahlen.
          </p>

          <h2>7. Zahlung</h2>
          <p>
            Die Zahlung erfolgt nach den jeweils angebotenen Zahlungsmethoden,
            insbesondere online, vor Ort, per Karte, in bar, per Rechnung oder über
            einen Zahlungsdienstleister.
          </p>
          <p>
            Eine gebuchte Leistung ist grundsätzlich im Voraus oder spätestens vor
            Beginn der Massage zu bezahlen, sofern nicht ausdrücklich etwas anderes
            vereinbart wurde.
          </p>
          <p>
            Bei nicht rechtzeitiger Zahlung ist die MediConsult GmbH berechtigt, den
            Termin nicht durchzuführen. Ein Anspruch auf Durchführung zu einem
            späteren Zeitpunkt besteht nicht.
          </p>

          <h2>8. Terminbindung, Verspätung und Nichterscheinen</h2>
          <p>Gebuchte Termine <b>sind verbindlich.</b></p>
          <p>
            Erscheint der Kunde nicht zum vereinbarten Termin, sagt er den Termin ab,
            verlegt er den Termin einseitig oder nimmt er den Termin aus Gründen
            nicht wahr, die nicht von der MediConsult GmbH zu vertreten sind, besteht
            kein Anspruch auf Rückerstattung, Ersatztermin oder Gutschrift.
          </p>
          <p>
            Bei Verspätung des Kunden verkürzt sich die Massagezeit entsprechend. Ab
            einer Verspätung von mehr als <b>5 Minuten</b> kann der Termin vollständig
            entfallen. Dies gilt insbesondere bei Wake-up-Massagen und Aktionsmassagen,
            da diese eng getaktet sind.
          </p>
          <p>
            Auch bei Studiomassagen, Außendienstmassagen, Hotelmassagen und sonstigen
            gebuchten Terminen besteht bei Verspätung, Absage oder Nichterscheinen
            grundsätzlich kein Anspruch auf Erstattung oder Nachholung.
          </p>
          <p>
            Die MediConsult GmbH kann aus Kulanz einen Ersatztermin anbieten. Ein
            Anspruch hierauf besteht jedoch nicht.
          </p>
          <p>
            Bei Terminen mit Zahlung vor Ort muss die Absage mindestens <b>4 Stunden</b> vor  
            dem vereinbarten Termin erfolgen. Erfolgt keine rechtzeitige Absage
            oder erscheint der Kunde nicht, kann die vereinbarte Verguetung per
            Rechnung geltend gemacht werden.
          </p>
          <p>
            Bei Online-Zahlung besteht kein Anspruch auf Rueckerstattung. Online
            bezahlte Termine können höchstens auf einen neuen Termin zum selben
            Preis umgebucht werden. Eine Umbuchung ist nur möglich, wenn der Termin
            mindestens <b>24 Stunden</b> vorher abgesagt bzw. die Umbuchung angefragt
            wird.
          </p>

          <h2>9. Absage oder Verlegung durch die MediConsult GmbH</h2>
          <p>
            Die MediConsult GmbH ist berechtigt, Termine aus wichtigem Grund
            abzusagen oder zu verlegen, insbesondere bei Krankheit, technischen
            Störungen, Ausfall von Personal, behördlichen Vorgaben, höherer Gewalt,
            organisatorischen Gründen oder sonstigen Umständen, die eine Durchführung
            unmöglich oder unzumutbar machen.
          </p>
          <p>
            In diesem Fall wird dem Kunden nach Wahl der MediConsult GmbH ein
            Ersatztermin angeboten oder eine bereits geleistete Zahlung erstattet.
          </p>
          <p>
            Weitergehende Ansprüche des Kunden, insbesondere Schadensersatz, Ersatz
            von Reise-, Hotel-, Verdienstausfall- oder sonstigen Folgekosten, sind
            ausgeschlossen, soweit gesetzlich zulässig.
          </p>

          <h2>10. Wake-up-Massage, Registrierung und Aktionsbedingungen</h2>
          <p>
            Die Wake-up-Massage ist ein vergünstigtes Aktionsangebot. Der reduzierte
            Preis von derzeit <b>5,00 Euro</b> gilt nur, wenn der Kunde den
            vorgesehenen Registrierungsprozess vollständig durchläuft und die für die
            Aktion vorgesehenen Bedingungen akzeptiert.
          </p>
          <p>Hierzu können insbesondere gehören:</p>
          <ul>
            <li>Angabe der erforderlichen Kontaktdaten</li>
            <li>Zustimmung zur Kontaktaufnahme</li>
            <li>Einwilligung in Foto-, Film-, Ton- und Interviewaufnahmen</li>
            <li>Einwilligung in die werbliche Nutzung dieser Aufnahmen</li>
            <li>Teilnahme an kurzen Feedback-, Interview- oder Promotionformaten</li>
          </ul>
          <p>
            Möchte der Kunde diese Bedingungen nicht akzeptieren, insbesondere keine
            Foto-, Film- oder Tonaufnahmen erlauben oder keine Daten angeben, kann er,
            sofern verfügbar, die Wake-up-Massage zum regulären Aktionspreis ohne
            Registrierungs- und Medienfreigabe in Höhe von derzeit <b>10,00 Euro</b> buchen.
          </p>
          <p>
            Ein Anspruch auf Durchführung einer Wake-up-Massage besteht nur im Rahmen
            verfügbarer Termine und Kapazitäten.
          </p>

          <p>
            Ein Rabatt von 50 % gilt ausschliesslich fuer Wake-up-Massagen und nicht
            fuer Classic-, Intense- oder sonstige Massageangebote.
          </p>

          <h2>11. Foto-, Film-, Ton- und Interviewaufnahmen</h2>
          <p>
            Bei Wake-up-Massagen, Aktionsmassagen, Events, Außendiensteinsätzen,
            Promotionaktionen und ähnlichen Formaten können Foto-, Film-, Ton- und
            Interviewaufnahmen erstellt werden.
          </p>
          <p>
            Soweit der Kunde hierzu gesondert einwilligt, räumt er der MediConsult
            GmbH das Recht ein, die erstellten Aufnahmen zeitlich, räumlich und
            inhaltlich unbeschränkt zu nutzen, zu bearbeiten, zu vervielfältigen, zu
            veröffentlichen und zu verbreiten, insbesondere für Werbung, Social Media,
            Website, Printmaterialien, Präsentationen, Pressearbeit, Schulungen,
            interne Dokumentation und sonstige Marketingzwecke im Zusammenhang mit
            Dr. Hoffmann-Massagen.
          </p>
          <p>
            Die Einwilligung umfasst insbesondere die Nutzung auf Websites,
            Landingpages, Instagram, Facebook, TikTok, YouTube, LinkedIn,
            Google-Unternehmensprofilen, Flyern, Broschüren, Messe- und
            Präsentationsmaterialien sowie sonstigen digitalen und analogen
            Werbemitteln.
          </p>
          <p>
            Der Kunde erhält hierfür keine gesonderte Vergütung, sofern nicht
            ausdrücklich schriftlich etwas anderes vereinbart wurde.
          </p>
          <p>
            Die MediConsult GmbH ist berechtigt, Aufnahmen auszuwählen, zu schneiden,
            zu bearbeiten, mit Text, Musik, Grafiken oder Logos zu versehen und im
            Rahmen der werblichen Kommunikation einzusetzen.
          </p>
          <p>
            Die Einwilligung in Foto-, Film-, Ton- und Interviewaufnahmen erfolgt
            freiwillig. Wird die Einwilligung nicht erteilt, kann der reduzierte
            Wake-up-Aktionspreis von 5,00 Euro entfallen; in diesem Fall kann der
            Kunde die Leistung, soweit verfügbar, zum Preis von 10,00 Euro ohne
            entsprechende Medienfreigabe buchen.
          </p>
          <p>
            Datenschutzrechtliche Hinweise zur Verarbeitung personenbezogener Daten,
            insbesondere zu Betroffenenrechten, Speicherdauer, Rechtsgrundlagen und
            Widerrufsmöglichkeiten, ergeben sich ergänzend aus der Datenschutzerklärung
            der MediConsult GmbH.
          </p>

          <h2>12. Datenschutz und Kontaktaufnahme</h2>
          <p>
            Die Verarbeitung personenbezogener Daten erfolgt nach Maßgabe der jeweils
            geltenden Datenschutzerklärung.
          </p>
          <p>
            Bei Buchungen, Registrierungen, Aktionsangeboten und Wake-up-Massagen
            können personenbezogene Daten verarbeitet werden, insbesondere Name,
            Kontaktdaten, Buchungsdaten, Zahlungsdaten, Gesundheitsangaben im
            erforderlichen Umfang sowie Foto-, Film-, Ton- und Interviewdaten, soweit
            eine entsprechende Einwilligung vorliegt.
          </p>
          <p>
            Der Kunde erklärt sich damit einverstanden, im Zusammenhang mit seiner
            Buchung, Terminabwicklung, Rückfragen, Feedback, Folgeangeboten und
            Informationen zur Dr. Hoffmann-Massage kontaktiert zu werden, soweit
            hierfür eine rechtliche Grundlage oder Einwilligung besteht.
          </p>

          <h2>13. Gutscheine, Aktionen und Rabatte</h2>
          <p>
            Gutscheine, Rabatte, Aktionspreise und Sonderangebote gelten nur im
            angegebenen Zeitraum, nur bei Verfügbarkeit und nur zu den jeweils
            genannten Bedingungen.
          </p>
          <p>Eine Barauszahlung ist ausgeschlossen.</p>
          <p>
            Aktionsangebote können jederzeit geändert, beendet oder begrenzt werden,
            soweit sie noch nicht verbindlich gebucht und bezahlt wurden.
          </p>
          <p>
            Mehrere Rabatte, Gutscheine oder Aktionen sind nicht kombinierbar, sofern
            nicht ausdrücklich etwas anderes angegeben ist.
          </p>

          <h2>14. Verhalten des Kunden</h2>
          <p>
            Der Kunde verpflichtet sich zu einem respektvollen, hygienischen und
            angemessenen Verhalten gegenüber Mitarbeitern, Partnern, Masseuren,
            anderen Kunden und Dritten.
          </p>
          <p>
            Die MediConsult GmbH ist berechtigt, Kunden von der Leistung
            auszuschließen oder laufende Leistungen abzubrechen, wenn der Kunde sich
            unangemessen verhält, Anweisungen nicht befolgt, falsche Angaben macht,
            Sicherheits- oder Hygienevorgaben missachtet oder die Durchführung der
            Massage stört.
          </p>
          <p>In diesen Fällen besteht kein Anspruch auf Erstattung.</p>

          <h2>15. Haftung</h2>
          <p>
            Die MediConsult GmbH haftet unbeschränkt bei Vorsatz und grober
            Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit
            nach den gesetzlichen Vorschriften.
          </p>
          <p>
            Bei einfacher Fahrlässigkeit haftet die MediConsult GmbH nur bei
            Verletzung wesentlicher Vertragspflichten. Wesentliche Vertragspflichten
            sind solche Pflichten, deren Erfüllung die ordnungsgemäße Durchführung
            des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der Kunde
            regelmäßig vertrauen darf. In diesem Fall ist die Haftung auf den
            vertragstypischen, vorhersehbaren Schaden begrenzt.
          </p>
          <p>Eine weitergehende Haftung ist ausgeschlossen, soweit gesetzlich zulässig.</p>
          <p>
            Die MediConsult GmbH haftet nicht für Schäden, Beschwerden oder
            gesundheitliche Folgen, die darauf beruhen, dass der Kunde unvollständige
            oder falsche Angaben zu seinem Gesundheitszustand macht, bestehende
            Risiken verschweigt, ärztlichen Rat nicht einholt, Hinweise nicht beachtet
            oder während der Massage Beschwerden nicht unverzüglich mitteilt.
          </p>
          <p>
            Die MediConsult GmbH haftet nicht für den Verlust oder die Beschädigung
            mitgebrachter Gegenstände, Kleidung, Wertsachen, Mobiltelefone, Taschen
            oder sonstiger persönlicher Gegenstände, es sei denn, der Schaden wurde
            vorsätzlich oder grob fahrlässig verursacht.
          </p>
          <p>
            Eine Haftung für mittelbare Schäden, Folgeschäden, entgangenen Gewinn,
            Verdienstausfall, Reise- oder Übernachtungskosten ist ausgeschlossen,
            soweit gesetzlich zulässig.
          </p>

          <h2>16. Keine Garantie bestimmter Wirkungen</h2>
          <p>
            Die MediConsult GmbH schuldet die fachgerechte Durchführung der gebuchten
            Wellnessdienstleistung, jedoch keinen bestimmten körperlichen,
            gesundheitlichen, therapeutischen, sportlichen, optischen oder sonstigen
            Erfolg.
          </p>
          <p>
            Subjektive Empfindungen wie Entspannung, Aktivierung, Wohlbefinden,
            Regeneration oder Lockerung können individuell unterschiedlich ausfallen.
          </p>

          <h2>17. Partner, Lizenznehmer und Außendienst</h2>
          <p>
            Dr. Hoffmann-Massagen können durch die MediConsult GmbH selbst, durch
            Mitarbeiter, geschulte Partner, Lizenznehmer, Studios, Hotels oder
            sonstige Kooperationspartner durchgeführt werden.
          </p>
          <p>
            Soweit ein Partner oder Lizenznehmer im eigenen Namen und auf eigene
            Rechnung handelt, kommt der Vertrag unmittelbar zwischen dem Kunden und
            dem jeweiligen Partner oder Lizenznehmer zustande. Hierauf wird der Kunde
            im jeweiligen Buchungsprozess oder vor Ort hingewiesen.
          </p>
          <p>
            Soweit die MediConsult GmbH lediglich vermittelt, haftet sie nicht für die
            Durchführung der Leistung durch den jeweiligen Partner, soweit gesetzlich
            zulässig.
          </p>

          <h2>18. Widerrufsrecht bei Onlinebuchungen</h2>
          <p>
            Verbrauchern kann bei online, telefonisch oder außerhalb von
            Geschäftsräumen geschlossenen Verträgen grundsätzlich ein gesetzliches
            Widerrufsrecht zustehen.
          </p>
          <p>
            Das Widerrufsrecht kann jedoch unter den gesetzlichen Voraussetzungen
            vorzeitig erlöschen, wenn der Kunde ausdrücklich verlangt, dass die
            Dienstleistung vor Ablauf der Widerrufsfrist beginnen soll, und bestätigt,
            dass er bei vollständiger Vertragserfüllung sein Widerrufsrecht verliert.
          </p>
          <p>
            Bei termingebundenen Dienstleistungen kann das Widerrufsrecht gesetzlich
            eingeschränkt oder ausgeschlossen sein, soweit die gesetzlichen
            Voraussetzungen vorliegen.
          </p>
          <p>Weitere Einzelheiten ergeben sich aus der jeweils bereitgestellten Widerrufsbelehrung.</p>

          <h2>19. Änderungen der AGB</h2>
          <p>
            Die MediConsult GmbH ist berechtigt, diese AGB mit Wirkung für die Zukunft
            zu ändern.
          </p>
          <p>
            Für bereits abgeschlossene Buchungen gelten die zum Zeitpunkt der Buchung
            einbezogenen AGB, sofern keine zwingenden gesetzlichen Vorschriften
            entgegenstehen.
          </p>

          <h2>20. Gerichtsstand und anwendbares Recht</h2>
          <p>Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</p>
          <p>
            Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder
            öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand
            für alle Streitigkeiten aus oder im Zusammenhang mit diesem Vertrag{" "}
            <b>Hamburg</b>.
          </p>
          <p>Gegenüber Verbrauchern gilt der gesetzliche Gerichtsstand.</p>

          <h2>21. Salvatorische Klausel</h2>
          <p>
            Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam
            sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen
            unberührt.
          </p>
          <p>Anstelle der unwirksamen Bestimmung gelten die gesetzlichen Vorschriften.</p>

          <h2>22. Stand</h2>
          <p>Stand dieser AGB: <b>01.07.2026</b></p>
        </div>
      </section>
    </Layout>
  );
};

export default AgbsPage;
